/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: gavin chan
 * @Date: 2020-08-12 10:23:48
 * @LastEditors: gavin chan
 * @LastEditTime: 2020-09-03 16:52:38
 * @Notes:
 */
import React from "react";
import {
  // Layout,
  // Modal,
  Form,
  Input,
  // Checkbox,
  Button,
  Space,
  // InputNumber,
  // DatePicker,
  Select,
  Divider,
  // Radio,
  Row,
  Col,
  // Affix,
  Typography,
  message,
  // Tree,
  TreeSelect,
} from "antd";
import { layout, formStyle } from "containers/common/layout";
// import moment from "moment";
// import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { RootState, RootDispatch } from "store";
import { FormInstance } from "antd/lib/form";
// import { start } from "repl";
import { Reg } from "utils/reg";

// const { Content } = Layout;
const { Title } = Typography;
const { Option } = Select;
// const { RangePicker } = DatePicker;
// const { TextArea } = Input;

const mapState = (state: RootState) => ({
  coupons: state.coupons.coupons,
  loading: state.loading.global,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  getProductCate: () => dispatch.coupons.getProductCate(),
  addCoupon: (data) => dispatch.coupons.addCoupon(data),
  getCouponDetail: (data) => dispatch.coupons.getCouponDetailAsync(data),
});

type connectedProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>;
type Props = connectedProps;

class CouponEditor extends React.Component<
  Props & RouteComponentProps<any, any>
> {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(props: Props & RouteComponentProps<any, any>) {
    super(props);

    this.onFinish = this.onFinish.bind(this);
  }

  state = {
    // visible: false,
    // couponUseLimit: 1,
    // dataId: 0,
    // pageTitle: "新增",
    // fieldDisabled: false,
    categories: [],
    // initialValues: {} as any,
  };

  refFormCouponDetail = React.createRef<FormInstance>();

  onFinish(values: any) {
    const { addCoupon } = this.props;
    console.log(this.props.history, this.context);
    const { match, history } = this.props as { match?: any; history?: any };
    const {
      params: { id },
    } = match;
    addCoupon({
      ...values,
      type: 1,
      time_type: 0,
      id: id === "add" ? null : id,
    }).then((res: any) => {
      if (res.code === "0000") {
        message.success("操作成功");
        history.goBack();
      } else {
        message.error("操作失败," + res.msg);
      }
    });
  }

  componentDidMount() {
    const { match } = this.props as { match?: any };
    const {
      params: { id },
    } = match;
    if (match.params.id > 0) {
      this.props.getCouponDetail({ id }).then((res: any) => {
        if (res.code === "0000") {
          // 商品分类接口给的id是数字,需要将详情接口的字符串转成数字类型的数组
          const category = res.data.category
            .split(",")
            .map((category) => category * 1);
          console.log(res.data.category, category);
          this.refFormCouponDetail.current.setFieldsValue({
            ...res.data,
            category: category,
          });
        }
      });
    }

    // 获取商品分类
    this.props.getProductCate().then((res: any) => {
      if (res.code === "0000") {
        // res.data.splice(0, 0, { id: 0, name: "全品类" });
        const categories = res.data.map((res: any) => {
          return { title: res.name, value: res.id, key: res.id };
        });
        this.setState({
          categories: [
            { title: "全品类", value: 0, key: 0, children: categories },
          ],
        });
        // this.setState({
        //   categories: res.data,
        // });
      } else {
        message.error("商品分类接口错误~");
      }
    });
  }

  render() {
    const maxStyle = {
      width: "403px",
    };
    const minStyle = {
      width: "95px",
      marginLeft: "10px",
      marginRight: "10px",
    };

    const { match } = this.props as { match?: any };
    const {
      params: { id },
    } = match;
    const { loading } = this.props;

    const { categories } = this.state;

    const startDates: any[] = [];
    for (let i = 1; i <= 14; i++) {
      startDates.push(i * 1);
    }

    return (
      <div>
        <div className="page-title">
          <Title level={3}>{id === "add" ? "添加" : "编辑"}优惠券</Title>
        </div>
        <Divider />
        <Row>
          <Col span={12}>
            <Form
              {...layout}
              name="addCoupon"
              onFinish={this.onFinish}
              size="large"
              style={formStyle}
              ref={this.refFormCouponDetail}
            >
              <Form.Item
                label="名称"
                name="name"
                rules={[
                  {
                    required: true,
                    max: 10,
                    message: "请输入不超过10个字符",
                    type: "string",
                  },
                ]}
              >
                <Input style={maxStyle} />
              </Form.Item>

              <Form.Item
                label="面额"
                name="quota"
                rules={[
                  {
                    required: true,
                    pattern: Reg.intPositve,
                    message: "请输入不小于0的整数",
                  },
                ]}
              >
                <Input
                  addonAfter="￥"
                  style={maxStyle}
                  disabled={id !== "add"}
                />
              </Form.Item>

              <Form.Item
                label="库存"
                name="stock"
                rules={[
                  {
                    required: true,
                    pattern: Reg.intPositve,
                    message: "请输入不小于0的整数",
                  },
                ]}
              >
                <Input addonAfter="张" style={maxStyle} />
              </Form.Item>

              <Form.Item
                label="每人限领"
                name="limited"
                rules={[
                  {
                    required: true,
                    pattern: Reg.intPositve,
                    message: "请输入不小于0的整数",
                  },
                ]}
              >
                <Input addonAfter="张" style={maxStyle} />
              </Form.Item>

              <Form.Item
                label="适用类目"
                name="category"
                rules={[{ required: true }]}
                initialValue={0}
              >
                {loading ? null : (
                  <TreeSelect
                    style={maxStyle}
                    treeCheckable={true}
                    showCheckedStrategy={"SHOW_PARENT"}
                    treeData={categories}
                    disabled={id !== "add"}
                  />
                )}
              </Form.Item>

              <Form.Item
                required
                label="有效期"
                style={{ marginBottom: 0 }}
                rules={[{ required: true }]}
              >
                领取后
                <Form.Item
                  name="start"
                  style={{
                    display: "inline-block",
                    verticalAlign: "baseline",
                  }}
                  initialValue={"0"}
                  rules={[{ required: true, message: "必填" }]}
                >
                  <Select size="middle" style={minStyle}>
                    <Option value={"0"}>当天</Option>
                    {startDates.map((option: any) => {
                      return (
                        <Option key={option} value={option}>
                          {option + "天"}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                生效,有效期
                <Form.Item
                  name="end"
                  style={{ display: "inline-block", verticalAlign: "baseline" }}
                  rules={[
                    {
                      required: true,
                      type: "integer",
                      min: 1,
                      message: "请输入大于0的整数",
                      transform: (value) => value * 1,
                    },
                  ]}
                >
                  <Input size="middle" style={minStyle} />
                </Form.Item>
                天
              </Form.Item>

              <Form.Item required label="使用条件">
                <span>满</span>
                <Form.Item
                  name="full"
                  noStyle
                  style={{ display: "inline-block" }}
                  rules={[
                    {
                      required: true,
                      pattern: Reg.intPositve,
                      message: "请输入不小于0的整数",
                    },
                  ]}
                  initialValue={0}
                >
                  <Input
                    style={minStyle}
                    size="middle"
                    disabled={id !== "add"}
                  />
                </Form.Item>
                <span>元可用</span>
              </Form.Item>

              <Divider />

              <div style={{ textAlign: "center" }}>
                <Space size="large">
                  <Button
                    onClick={() => {
                      const { history } = this.props as { history?: any };
                      history.goBack();
                    }}
                  >
                    返回
                  </Button>
                  <Button type="primary" htmlType="submit">
                    确认提交
                  </Button>
                </Space>
              </div>
            </Form>
          </Col>
          {/* <Col span={12}>
            <Affix offsetTop={50}>
              <h4 style={{ textAlign: "center" }}>效果预览：</h4>
              <div className="preview">
                <div className="header">
                  <div className="page-title">优惠券</div>
                </div>
                <div className="content-bg">
                  <div className="content">
                    <div className="price">
                      ￥<Text className="value">10</Text>
                    </div>

                    <div className="rule">订单满50元可用</div>

                    <div className="rule2">
                      全场通用券
                      <br />
                      领取后30天有效
                    </div>

                    <div className="signet"></div>

                    <div className="btn-group">
                      <div>
                        <Button className="btn-yellow" shape="round" block>
                          立即领取
                        </Button>
                      </div>
                      <div>
                        <Button className="btn-yellow" shape="round" block>
                          查看我的优惠券
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Affix>
          </Col> */}
        </Row>
      </div>
    );
  }
}

export default connect(mapState, mapDispatch)(withRouter(CouponEditor));
